import React from 'react';
import { useQuery } from 'react-query';
import { useServiceClient } from 'common';
import { MyAppsEndPoints, MyAppsQueryKey } from './query-enums';

export const useDownloadMobilePackageQuery = (buildRequestId: string) => {
    const { getData } = useServiceClient();
    const appDetails = React.useCallback(() => getData(`${MyAppsEndPoints.DOWNLOAD_MOBILE_PACKAGE}/${buildRequestId}`), [buildRequestId, getData]);
    return useQuery(MyAppsQueryKey.DOWNLOAD_MOBILE_PACKAGE, appDetails, {
        refetchOnWindowFocus: false,
        enabled: false
    });
};

export const useOptionalDownloadMobilePackageQuery = () => {
    const { getData } = useServiceClient();
    const appDetails = React.useCallback((buildRequestId) => getData(`${MyAppsEndPoints.DOWNLOAD_MOBILE_PACKAGE}/${buildRequestId}`), [getData]);
    return [appDetails];
};
